exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-item.expanded[data-v-54f39fc9]{animation:fadeInRightCustom-data-v-54f39fc9 .7s ease-out}@keyframes fadeInRightCustom-data-v-54f39fc9{0%{opacity:0;transform:translateX(100%)}to{opacity:1;transform:translateX(0)}}#tabcontainer1[data-v-54f39fc9]{position:absolute;display:inline-table;right:0;transform:rotate(90deg)}.tab-item[data-v-54f39fc9]{display:inline-table;margin:auto;overflow:visible}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54f39fc9","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/containers/vertical-tabs.vue
// module id = 1493
// module chunks = 0